import { DocumentType, DocumentInputType, Gender } from '~/common/model'

export interface FetchCustomerProps {
  documentType: DocumentInputType
  document: string
  brand: string
  sub: string
}

export interface UpdateCustomerProps {
  customerId: string
  email: string
  brand: string
  sub: string
}

export interface UpdateCustomerResponse {
  total: number
  items: {
    id: string // customerId
    status: string
    message: string
  }[]
}

export enum CustomerType {
  INDIVIDUAL = 'INDIVIDUAL',
  COMPANY = 'COMPANY',
}

export enum CustomerSector {
  RESIDENTIAL = 'RESIDENTIAL',
  COMPANY = 'COMPANY',
  SELF_EMPLOYED = 'SELF_EMPLOYED',
  HORECA = 'HORECA',
  UNKNOWN = 'UNKNOWN',
}

export interface PersonalData {
  firstName: string
  middleName: string
  lastName: string
  gender: Gender
  birthDate: string
  otherPhone: string
  email: string
}

export interface BusinessData {
  company: string
  createdDate: string
  otherPhone: string
  email: string
}

export interface AddressData {
  address: string
  state: string
  stateId: number
  zipCode: number
  locality: string
}

export interface BundleData {
  id: string
  type: string
  typeDescription: string
  installationAddress: string
}

export interface Package {
  bundle: BundleData
  subscriptions: Subscription[]
}

export enum AccountStatus {
  ACTIVATED = 'ACTIVATED',
  TERMINATED = 'TERMINATED',
  TEMPORARY_LOCKED = 'TEMPORARY_LOCKED',
  ACCEPTANCE_PENDING = 'ACCEPTANCE_PENDING',
}

export interface Account {
  id: string
  ownerId: string
  accountNumber: string
  status: AccountStatus
  packages: Package[]
  hasContract?: boolean
}

export interface Customer {
  id: string
  languageCode: string
  documentType: DocumentType
  documentValue: string
  sector: CustomerSector
  type: CustomerType
  originCountryCode: string
  activationDate?: string
  personal: PersonalData
  business: BusinessData
  addressInfo: AddressData
  accounts: Account[]
}

export enum SubscriptionStatusGroup {
  ACTIVE = 'ACTIVE',
  ON_FLY = 'ON_FLY',
  LOCKED = 'LOCKED',
  TERMINATED = 'TERMINATED',
  PENDING = 'PENDING',
  NO_GROUP = 'NO_GROUP',
}

export enum SubscriptionStatus {
  INSTALLED = 'INSTALLED',
  PREACTIVATED = 'PREACTIVATED',
  ACTIVATED = 'ACTIVATED',
  LOCKED_DUE_BALANCE = 'LOCKED_DUE_BALANCE',
  TERMINATED = 'TERMINATED',
  TEMPORARY_LOCKED = 'TEMPORARY_LOCKED',
  TERMINATION_PENDING = 'TERMINATION_PENDING',
  LOCKED_DUE_CONSUMPTION_LIMIT = 'LOCKED_DUE_CONSUMPTION_LIMIT',
  SUSPENSION_PENDING = 'SUSPENSION_PENDING',
  RECONNECTION_PENDING = 'RECONNECTION_PENDING',
  OK = 'OK',
  TEMPORARY_LOCK_PENDING = 'TEMPORARY_LOCK_PENDING',
  UNKNOWN = 'UNKNOWN',
}

export enum SubscriptionType {
  PREPAID = 'PREPAID',
  POSTPAID = 'POSTPAID',
  ANALOG_FIXED = 'ANALOG_FIXED',
  DIGITAL_FIXED = 'DIGITAL_FIXED',
  ADSL = 'ADSL',
  FFTH = 'FFTH',
  AGILE_TV = 'AGILE_TV',
  UNKNOWN = 'UNKNOWN',
}

export interface CommercialProduct {
  description: string
  id: string
}

export interface Subscription {
  id: string
  userId: string
  identificationNr: string
  expeditionUserId: string
  status: SubscriptionStatus
  type: SubscriptionType
  commercialProduct: CommercialProduct
  statusGroup: SubscriptionStatusGroup
}
